/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useMemo, useState } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { deleteLabel } from '../../../../../../../../../app/page/page-storage/labels/labels.actions';
import { updateTaskSimple } from '../../../../../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { labelSelectors } from '../../../../../../../../../app/resource/label/label.selectors';
import { taskSimpleSelectors } from '../../../../../../../../../app/resource/task-simple/task-simple.selectors';
import { useSelectWithParams } from '../../../../../../../../../utils/selector.utils';
import { LabelForm } from '../../../../../../forms/LabelForm';

import { ILabelProps } from './types';

export const Label: FunctionComponent<ILabelProps> = ({ labelId, taskId }) => {
  const label = useSelectWithParams(labelSelectors.selectResourceById, labelId);
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId ?? '');

  const taskLabels = useMemo(() => {
    if (task && task.labels) {
      return task.labels;
    }
    return [];
  }, [task]);

  const [isActive, setActive] = useState(false);
  const labelFiltered = useMemo(() => {
    if (label) {
      return taskLabels.filter((taskLabel) => taskLabel === label.id);
    }
    return taskLabels;
  }, [label, taskLabels]);
  const [isSelected, setSelected] = useState(labelFiltered.length > 0 ? true : false);

  const dispatch = useDispatch();
  const toggleClass = (status: boolean) => {
    setActive(!status);
  };
  const onDeleteLabel = useCallback(() => {
    dispatch(deleteLabel(labelId));
  }, [dispatch, labelId]);

  const addTaskLabel = useCallback(() => {
    if (label && task) {
      const updatedTask = {
        labels: [...taskLabels, label.id],
      };
      dispatch(updateTaskSimple(task.id, updatedTask));
    }
  }, [dispatch, label, task, taskLabels]);

  const deleteTaskLabel = useCallback(() => {
    if (label && task) {
      const updatedTask = {
        labels: taskLabels.filter((taskLabel) => taskLabel !== label.id),
      };
      dispatch(updateTaskSimple(task.id, updatedTask));
    }
  }, [dispatch, label, task, taskLabels]);

  const toggleSelect = () => {
    isSelected ? deleteTaskLabel() : addTaskLabel();
    setSelected(!isSelected);
  };

  return (
    label && (
      <div
        className={
          isActive
            ? isSelected
              ? 'one-label selected edited'
              : 'one-label edited'
            : isSelected
            ? 'one-label selected'
            : 'one-label'
        }
        key={`labelId-${label.id}`}
      >
        <a className={`badge jcl`} style={{ backgroundColor: `${label.color}` }} onClick={toggleSelect}>
          {label.name}
        </a>
        <span className="edit-label" key={`labelId-${label.id}`} onClick={() => toggleClass(isActive)}>
          <i className="icon icon-pencil" />
        </span>
        {isActive && (
          <div className="edit-label-container">
            {task && task.meetingIds?.[0] && (
              <LabelForm labelData={label} onClick={toggleClass} meetingId={task.meetingIds[0]} />
            )}
            <button className="btn btn-sm red-bg delete-label" onClick={onDeleteLabel}>
              Delete label
            </button>
          </div>
        )}
      </div>
    )
  );
};
